import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { animateToBooth } from "../../animations/animateToBooth";
import { useMobileBrowser } from "../../hooks/useMobileBrowser";
import { IBooth } from "../../store/interfaces/IBooth";
import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";
import { useRouterStore } from "../../store/useRouterStore";

const SingleBoothViewFiberComponent = () => {
  const {
    isBoothVisitPartActive,
    isSingleBoothViewButtonPressed,
    setIsBoothVisitPartActive,
    setIsSingleBoothViewButtonPressed,
  } = useComponentLoadingStateStore();
  const { boothID } = useRouterStore();
  const { camera, scene } = useThree();
  const { isMobileBrowser } = useMobileBrowser();
  useEffect(() => {
    if (!isBoothVisitPartActive || !isSingleBoothViewButtonPressed || !boothID)
      return;
    const activeBooth = scene.getObjectByName(boothID);
    animateToBooth(
      camera,
      activeBooth?.children[0] as unknown as IBooth,
      activeBooth?.children[0].parent?.userData.standSize,
      true,
      isMobileBrowser
    );
    setIsBoothVisitPartActive(false);
    setIsSingleBoothViewButtonPressed(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isBoothVisitPartActive,
    isSingleBoothViewButtonPressed,
    boothID,
    isMobileBrowser,
  ]);
  return <mesh></mesh>;
};

export default SingleBoothViewFiberComponent;
